import React, { useEffect, useRef } from 'react';
import CompanyInfo from '../../components/CompanyInfo';

const MarketingAndAdvertisingIndustry = () => {
 const canvasRef = useRef(null);
     const mousePosRef = useRef(null);
     const pointsRef = useRef([]);
     const animationRef = useRef(null);
   
     const maxDist = 200;
     const colour = "#FFFFFF";
   
     useEffect(() => {
       const canvas = canvasRef.current;
       const ctx = canvas.getContext("2d");
   
       // Point constructor
       class Point {
         constructor() {
           this.x = (Math.random() * (canvas.width + maxDist)) - (maxDist / 2);
           this.y = (Math.random() * (canvas.height + maxDist)) - (maxDist / 2);
           this.vx = (Math.random() * 2) - 1;
           this.vy = (Math.random() * 2) - 1;
           this.dia = Math.random() * 3 + 1;
         }
       }
   
       // Generate points
       const generatePoints = (amount) => {
         pointsRef.current = [];
         for (let i = 0; i < amount; i++) {
           pointsRef.current.push(new Point());
         }
       };
   
       // Draw function
       const draw = (obj) => {
         ctx.beginPath();
         ctx.fillStyle = colour;
         if (obj.dia) {
           ctx.arc(obj.x, obj.y, obj.dia, 0, 2 * Math.PI);
         } else {
           ctx.arc(obj.x, obj.y, 2, 0, 2 * Math.PI);
         }
         ctx.closePath();
         ctx.fill();
       };
   
       // Update function
       const update = (obj) => {
         obj.x += obj.vx;
         obj.y += obj.vy;
         if (obj.x > canvas.width + (maxDist / 2)) {
           obj.x = -(maxDist / 2);
         } else if (obj.x < -(maxDist / 2)) {
           obj.x = canvas.width + (maxDist / 2);
         }
         if (obj.y > canvas.height + (maxDist / 2)) {
           obj.y = -(maxDist / 2);
         } else if (obj.y < -(maxDist / 2)) {
           obj.y = canvas.height + (maxDist / 2);
         }
       };
   
       // Collision detection and line drawing
       const collision = (obj, dist) => {
         let temp;
         for (let i = 0; i < pointsRef.current.length; i++) {
           if (obj !== pointsRef.current[i]) {
             temp = Math.sqrt(
               Math.pow((obj.x - pointsRef.current[i].x), 2) + 
               Math.pow((obj.y - pointsRef.current[i].y), 2)
             );
             if (temp < dist) {
               ctx.beginPath();
               ctx.moveTo(obj.x, obj.y);
               ctx.strokeStyle = `rgba(255,255,255,${0.8 * Math.pow((dist - temp) / dist, 5)})`;
               ctx.moveTo(obj.x, obj.y);
               ctx.lineTo(pointsRef.current[i].x, pointsRef.current[i].y);
               ctx.closePath();
               ctx.stroke();
             }
           }
         }
       };
   
       // Main animation loop
       const pointFun = () => {
         ctx.clearRect(0, 0, canvas.width, canvas.height);
         if (mousePosRef.current) {
           collision(mousePosRef.current, maxDist * 2);
           draw(mousePosRef.current);
         }
         for (let i = 0; i < pointsRef.current.length; i++) {
           collision(pointsRef.current[i], maxDist);
           draw(pointsRef.current[i]);
           update(pointsRef.current[i]);
         }
       };
   
       // Resize canvas
       const resizeCanvas = () => {
         canvas.width = document.documentElement.clientWidth;
         canvas.height = window.innerHeight;
         generatePoints(170);
         pointFun();
       };
   
       // Mouse move handler
       const handleMouseMove = (evt) => {
         const rect = canvas.getBoundingClientRect();
         mousePosRef.current = {
           x: evt.clientX - rect.left,
           y: evt.clientY - rect.top
         };
       };
   
       // Initialize
       resizeCanvas();
       pointFun();
   
       // Start animation
       const interval = setInterval(pointFun, 16);
       animationRef.current = interval;
   
       // Event listeners
       window.addEventListener('resize', resizeCanvas);
       canvas.addEventListener('mousemove', handleMouseMove);
   
       // Cleanup
       return () => {
         clearInterval(interval);
         window.removeEventListener('resize', resizeCanvas);
         canvas.removeEventListener('mousemove', handleMouseMove);
       };
     }, []);
   
     return (
       <div style={{ 
         overflow: 'hidden',
         width: '100%',
         maxWidth: '100vw',
         position: 'relative',
            paddingTop: '130px'
       }}>
         <div style={{ 
           margin: 0, 
           padding: 0, 
           overflow: 'hidden',
           width: '100%',
           height: '60vh',
           position: 'relative'
         }}>
           <canvas
             ref={canvasRef}
             id="canvas"
             style={{
               overflow: 'hidden',
               cursor: 'none',
               position: 'absolute',
               top: 0,
               left: 0,
               width: '100%',
               height: '100%',
               background: 'linear-gradient(to bottom, #306873, #52A7B0)'
             }}
           />
           <div style={{
             position: 'absolute',
             top: '50%',
             left: '50%',
             transform: 'translate(-50%, -50%)',
             textAlign: 'center',
             zIndex: 1
           }}>
             <h2 style={{
               color: '#ffffff',
               fontSize: '3rem',
               fontWeight: 'bold',
               textShadow: '2px 2px 4px rgba(0,0,0,0.3)',
               maxWidth: '800px',
               margin: '0 auto'
             }}>
              Marketing & Advertising Staffing Solutions
             </h2>
             <p style={{
               color: '#ffffff',
               fontSize: '1.25rem',
               marginTop: '1rem',
               textShadow: '1px 1px 2px rgba(0,0,0,0.3)',
               maxWidth: '600px',
               margin: '1rem auto 0'
             }}>
              Amplify Your Brand with Remote Marketing Experts from <span className="workdeskva-brand"><span className="workdeskva-bold">Work</span><span className="workdeskva-light">Desk</span> <span className="workdeskva-va">VA</span></span>
             </p>
           </div>
         </div>
         
    
  <section className="section_space bg-white">
         <div className="container">
            {/* Service Description */}
            <div className="row justify-content-center mb-5">
              <div className="col-lg-10">
                <div className="heading_block">
                  <h2 className="heading_text mb-4">Elevate Your Marketing with Remote Talent</h2>
                  <p className="heading_description mb-4">
                    <span className="workdeskva-brand"><span className="workdeskva-bold">Work</span><span className="workdeskva-light">Desk</span> <span className="workdeskva-va">VA</span></span> connects you with skilled marketing and advertising professionals who work remotely to boost your campaigns, manage your brand, and drive measurable results. Our team supports agencies and in-house marketing departments with flexible, scalable staffing solutions tailored to your needs.
                  </p>
                  <p className="heading_description mb-4">
                    From digital marketing and content creation to campaign analytics and social media management, our experts handle the details so you can focus on creative strategy and business growth. Let us help you maximize your marketing ROI with reliable, vetted remote staff.
                  </p>
                  <div className="row mt-5">
                    <div className="col-md-6">
                      <div className="iconbox_block layout_icon_left mb-4">
                        <div className="iconbox_content">
                          <h4 className="iconbox_title">Digital Marketing Expertise</h4>
                          <p>SEO, SEM, email marketing, and paid ads managed by experienced professionals to grow your online presence.</p>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="iconbox_block layout_icon_left mb-4">
                        <div className="iconbox_content">
                          <h4 className="iconbox_title">Creative Content Production</h4>
                          <p>Engaging copywriting, graphic design, and video editing to make your brand stand out across all channels.</p>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="iconbox_block layout_icon_left mb-4">
                        <div className="iconbox_content">
                          <h4 className="iconbox_title">Campaign Management</h4>
                          <p>End-to-end campaign planning, execution, and reporting for consistent, high-impact results.</p>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="iconbox_block layout_icon_left mb-4">
                        <div className="iconbox_content">
                          <h4 className="iconbox_title">Brand Monitoring</h4>
                          <p>Active social listening and reputation management to protect and enhance your brand image.</p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="mt-4">
                    <p className="heading_description">
                      We support marketing and advertising teams in industries such as retail, technology, healthcare, and more. Our remote staffing solutions are tailored to your brand’s unique goals, ensuring you get the right talent for every campaign and channel.
                    </p>
                  </div>
                  <div className="row mt-4">
                    <div className="col-md-6">
                      <ul className="icon_list unordered_list_block">
                        <li>
                          <i className="fas fa-check icon_list_icon"></i>
                          <span>Remote staffing for all marketing roles</span>
                        </li>
                        <li>
                          <i className="fas fa-check icon_list_icon"></i>
                          <span>Quick onboarding and flexible contracts</span>
                        </li>
                        <li>
                          <i className="fas fa-check icon_list_icon"></i>
                          <span>Support for agencies and in-house teams</span>
                        </li>
                      </ul>
                    </div>
                    <div className="col-md-6">
                      <ul className="icon_list unordered_list_block">
                        <li>
                          <i className="fas fa-check icon_list_icon"></i>
                          <span>Transparent reporting and analytics</span>
                        </li>
                        <li>
                          <i className="fas fa-check icon_list_icon"></i>
                          <span>Data security and confidentiality</span>
                        </li>
                        <li>
                          <i className="fas fa-check icon_list_icon"></i>
                          <span>Continuous skills development</span>
                        </li>
                      </ul>
                    </div>
                  </div>
               </div>
             </div>
           </div>
           <CompanyInfo/>
          <div className="row mt-5">
            <div className="col-lg-12">
              <div className="heading_block mb-5">
                <h2 className="heading_text">Why Choose <span className="workdeskva-brand"><span className="workdeskva-bold">Work</span><span className="workdeskva-light">Desk</span> <span className="workdeskva-va">VA</span></span> for Marketing & Advertising?</h2>
              </div>
            </div>
          </div>
          <div className="row g-4 mb-5">
            <div className="col-lg-4 d-flex">
              <div className="iconbox_block" style={{
                border: '1px solid var(--bs-border-color)', 
                borderRadius: 'var(--bs-border-radius)',
                height: '100%',
                padding: '40px 30px',
                width: '100%',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'flex-start'
              }}>
                <div style={{
                  width: '80px',
                  height: '80px',
                  borderRadius: '50%',
                  backgroundColor: 'rgba(135, 206, 235, 0.2)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginBottom: '25px'
                }}>
                  <i className="fas fa-bullhorn" style={{ color: '#1995A2', fontSize: '24px' }}></i>
                </div>
                <h3 className="iconbox_title" style={{ fontSize: '24px', marginBottom: '20px', color: '#0C5660' }}>Specialized Marketing Talent</h3>
                <p style={{ fontSize: '16px', lineHeight: '1.6', margin: 0 }}>Access a pool of marketing strategists, content creators, and campaign managers ready to support your goals.</p>
              </div>
            </div>
            <div className="col-lg-4 d-flex">
              <div className="iconbox_block" style={{
                border: '1px solid var(--bs-border-color)', 
                borderRadius: 'var(--bs-border-radius)',
                height: '100%',
                padding: '40px 30px',
                width: '100%',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'flex-start'
              }}>
                <div style={{
                  width: '80px',
                  height: '80px',
                  borderRadius: '50%',
                  backgroundColor: 'rgba(135, 206, 235, 0.2)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginBottom: '25px'
                }}>
                  <i className="fas fa-lightbulb" style={{ color: '#1995A2', fontSize: '24px' }}></i>
                </div>
                <h3 className="iconbox_title" style={{ fontSize: '24px', marginBottom: '20px', color: '#0C5660' }}>Creative Solutions</h3>
                <p style={{ fontSize: '16px', lineHeight: '1.6', margin: 0 }}>Innovative ideas and fresh perspectives to keep your marketing ahead of the curve.</p>
              </div>
            </div>
            <div className="col-lg-4 d-flex">
              <div className="iconbox_block" style={{
                border: '1px solid var(--bs-border-color)', 
                borderRadius: 'var(--bs-border-radius)',
                height: '100%',
                padding: '40px 30px',
                width: '100%',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'flex-start'
              }}>
                <div style={{
                  width: '80px',
                  height: '80px',
                  borderRadius: '50%',
                  backgroundColor: 'rgba(135, 206, 235, 0.2)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginBottom: '25px'
                }}>
                  <i className="fas fa-users" style={{ color: '#1995A2', fontSize: '24px' }}></i>
                </div>
                <h3 className="iconbox_title" style={{ fontSize: '24px', marginBottom: '20px', color: '#0C5660' }}>Scalable Support</h3>
                <p style={{ fontSize: '16px', lineHeight: '1.6', margin: 0 }}>Easily scale your team up or down to match campaign cycles and business needs.</p>
              </div>
            </div>
          </div>
         </div>
  </section>
     </div>
   );
 };

export default MarketingAndAdvertisingIndustry;